export enum SparksActionTypes {
  GET_SPARKS_SUMMARY = "@@SPARKS/GET_SPARKS_SUMMARY",
  GET_SPARKS_SUMMARY_SUCCESS = "@@SPARKS/GET_SPARKS_SUMMARY_SUCCESS",
  GET_SPARKS_SUMMARY_FAILURE = "@@SPARKS/GET_SPARKS_SUMMARY_FAILURE",

  GET_USER_BADGES = "@@SPARKS/GET_USER_BADGES",
  GET_USER_BADGES_SUCCESS = "@@SPARKS/GET_USER_BADGES_SUCCESS",
  GET_USER_BADGES_FAILURE = "@@SPARKS/GET_USER_BADGES_FAILURE",

  GET_BADGE_DEFINITIONS = "@@SPARKS/GET_BADGE_DEFINITIONS",
  GET_BADGE_DEFINITIONS_SUCCESS = "@@SPARKS/GET_BADGE_DEFINITIONS_SUCCESS",
  GET_BADGE_DEFINITIONS_FAILURE = "@@SPARKS/GET_BADGE_DEFINITIONS_FAILURE",

  GET_PROFILE_BADGES = "@@SPARKS/GET_PROFILE_BADGES",
  GET_PROFILE_BADGES_SUCCESS = "@@SPARKS/GET_PROFILE_BADGES_SUCCESS",
  GET_PROFILE_BADGES_FAILURE = "@@SPARKS/GET_PROFILE_BADGES_FAILURE",

  // Phase 38 D5: two SEPARATE triads (below, and GET_LEADERBOARD_CROWNS further down) even though
  // both call the single api.getLeaderboard method -- see actions.tsx's own comment for why.
  GET_LEADERBOARD = "@@SPARKS/GET_LEADERBOARD",
  GET_LEADERBOARD_SUCCESS = "@@SPARKS/GET_LEADERBOARD_SUCCESS",
  GET_LEADERBOARD_FAILURE = "@@SPARKS/GET_LEADERBOARD_FAILURE",

  GET_LEADERBOARD_CROWNS = "@@SPARKS/GET_LEADERBOARD_CROWNS",
  GET_LEADERBOARD_CROWNS_SUCCESS = "@@SPARKS/GET_LEADERBOARD_CROWNS_SUCCESS",
  GET_LEADERBOARD_CROWNS_FAILURE = "@@SPARKS/GET_LEADERBOARD_CROWNS_FAILURE",

  SET_LEADERBOARD_BOARD = "@@SPARKS/SET_LEADERBOARD_BOARD",
  SET_LEADERBOARD_PERIOD = "@@SPARKS/SET_LEADERBOARD_PERIOD",
  CLEAR_LEADERBOARD = "@@SPARKS/CLEAR_LEADERBOARD",

  // overview-leaderboard-card-plan.md Part 2: the Overview rail card's OWN triad -- a THIRD,
  // independent action type calling the same api.getLeaderboard method as GET_LEADERBOARD/
  // GET_LEADERBOARD_CROWNS above, registered on its own takeLatest slot (saga.tsx) so toggling this
  // card's local board/period state can never cancel, or be cancelled by, the Leaderboard tab's own
  // fetches. Reset by CLEAR_SPARKS below, not a dedicated clear action of its own -- see
  // SparksState.interface.tsx's own comment for why.
  GET_OVERVIEW_LEADERBOARD = "@@SPARKS/GET_OVERVIEW_LEADERBOARD",
  GET_OVERVIEW_LEADERBOARD_SUCCESS = "@@SPARKS/GET_OVERVIEW_LEADERBOARD_SUCCESS",
  GET_OVERVIEW_LEADERBOARD_FAILURE = "@@SPARKS/GET_OVERVIEW_LEADERBOARD_FAILURE",

  CLEAR_SPARKS = "@@SPARKS/CLEAR_SPARKS",
  CLEAR_PROFILE_BADGES = "@@SPARKS/CLEAR_PROFILE_BADGES",

  // redeem-tab-plan.md PR2: the Redeem tab's OWN read of the logged-in user's redemption ledger.
  // Reset by CLEAR_SPARKS, not its own clear action -- this is the logged-in
  // user's own Sparks lifecycle, same as summary/badges/badgeDefinitions.
  GET_OWN_REDEMPTION_SUMMARY = "@@SPARKS/GET_OWN_REDEMPTION_SUMMARY",
  GET_OWN_REDEMPTION_SUMMARY_SUCCESS = "@@SPARKS/GET_OWN_REDEMPTION_SUMMARY_SUCCESS",
  GET_OWN_REDEMPTION_SUMMARY_FAILURE = "@@SPARKS/GET_OWN_REDEMPTION_SUMMARY_FAILURE",

  // overview-rebuild-pr5-plan.md: "Your giving week" block's own triad -- self-only (no userId, see
  // actions.tsx's own comment), part of the logged-in user's OWN Sparks lifecycle alongside
  // GET_SPARKS_SUMMARY/GET_USER_BADGES/GET_BADGE_DEFINITIONS above (reset together by CLEAR_SPARKS).
  GET_GIVING_ACTIVITY = "@@SPARKS/GET_GIVING_ACTIVITY",
  GET_GIVING_ACTIVITY_SUCCESS = "@@SPARKS/GET_GIVING_ACTIVITY_SUCCESS",
  GET_GIVING_ACTIVITY_FAILURE = "@@SPARKS/GET_GIVING_ACTIVITY_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-49-w1-rewards-catalog.md: the Redeem tab's real catalog read, replacing the hardcoded preview
  // module. No payload, unpaginated -- mirrors GET_BADGE_DEFINITIONS' own triad exactly.
  GET_REWARD_ITEMS = "@@SPARKS/GET_REWARD_ITEMS",
  GET_REWARD_ITEMS_SUCCESS = "@@SPARKS/GET_REWARD_ITEMS_SUCCESS",
  GET_REWARD_ITEMS_FAILURE = "@@SPARKS/GET_REWARD_ITEMS_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-49-w2-create-request.md: an employee raising a request against `POST /redemption-requests`
  // (A5) -- a NEW triad, distinct from the HR-gated `admin/redemptions` write (a client-supplied
  // price) that used to sit above this one; that write, CREATE_REDEMPTION, was deleted alongside the
  // mark-consumed flow in 923-core-context context/engineering/spark-rewards/phase-49-w5-org-wide-ledger.md. This one prices server-side from the
  // catalog, see actions.tsx's own comment.
  CREATE_REDEMPTION_REQUEST = "@@SPARKS/CREATE_REDEMPTION_REQUEST",
  CREATE_REDEMPTION_REQUEST_SUCCESS = "@@SPARKS/CREATE_REDEMPTION_REQUEST_SUCCESS",
  CREATE_REDEMPTION_REQUEST_FAILURE = "@@SPARKS/CREATE_REDEMPTION_REQUEST_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-49-w3-pending-requests-panel.md: the HR queue's own triad -- org-wide, independent of every
  // other trio in this file.
  GET_PENDING_REDEMPTION_REQUESTS = "@@SPARKS/GET_PENDING_REDEMPTION_REQUESTS",
  GET_PENDING_REDEMPTION_REQUESTS_SUCCESS = "@@SPARKS/GET_PENDING_REDEMPTION_REQUESTS_SUCCESS",
  GET_PENDING_REDEMPTION_REQUESTS_FAILURE = "@@SPARKS/GET_PENDING_REDEMPTION_REQUESTS_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-49-w4-approve-deny.md: per-row decisions, registered on takeEvery (saga.tsx) -- independent
  // of each other's action type, same reasoning as GET_LEADERBOARD/GET_LEADERBOARD_CROWNS above (two
  // independent fetches must not share one watcher).
  APPROVE_REDEMPTION_REQUEST = "@@SPARKS/APPROVE_REDEMPTION_REQUEST",
  APPROVE_REDEMPTION_REQUEST_SUCCESS = "@@SPARKS/APPROVE_REDEMPTION_REQUEST_SUCCESS",
  APPROVE_REDEMPTION_REQUEST_FAILURE = "@@SPARKS/APPROVE_REDEMPTION_REQUEST_FAILURE",

  DENY_REDEMPTION_REQUEST = "@@SPARKS/DENY_REDEMPTION_REQUEST",
  DENY_REDEMPTION_REQUEST_SUCCESS = "@@SPARKS/DENY_REDEMPTION_REQUEST_SUCCESS",
  DENY_REDEMPTION_REQUEST_FAILURE = "@@SPARKS/DENY_REDEMPTION_REQUEST_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-49-w4-approve-deny.md: the Redemptions TAB badge's OWN triad -- deliberately NOT a reuse of
  // GET_PENDING_REDEMPTION_REQUESTS above with `limit: 1` (see actions.tsx's own comment for the
  // pager-destroying alternative this avoids).
  GET_PENDING_REDEMPTION_REQUESTS_BADGE_COUNT = "@@SPARKS/GET_PENDING_REDEMPTION_REQUESTS_BADGE_COUNT",
  GET_PENDING_REDEMPTION_REQUESTS_BADGE_COUNT_SUCCESS = "@@SPARKS/GET_PENDING_REDEMPTION_REQUESTS_BADGE_COUNT_SUCCESS",
  GET_PENDING_REDEMPTION_REQUESTS_BADGE_COUNT_FAILURE = "@@SPARKS/GET_PENDING_REDEMPTION_REQUESTS_BADGE_COUNT_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-49-w5-org-wide-ledger.md: the org-wide ledger's own triad -- a FOURTH hand-written pager
  // (architecture §4.6, applied verbatim), independent of every other trio in this file.
  GET_REDEMPTION_LEDGER = "@@SPARKS/GET_REDEMPTION_LEDGER",
  GET_REDEMPTION_LEDGER_SUCCESS = "@@SPARKS/GET_REDEMPTION_LEDGER_SUCCESS",
  GET_REDEMPTION_LEDGER_FAILURE = "@@SPARKS/GET_REDEMPTION_LEDGER_FAILURE",

  // review fix A-C: the ledger's own dedicated reset -- for the PAGER state
  // (rows/total/loadedPages/lastPageWasFull/limit/loadFailed). Dispatched by RedemptionsContainer
  // immediately before its own page-0 request on mount -- see reducer.tsx's own comment for why a
  // page-0 request that then FAILS otherwise leaves every pager field describing a previous load.
  CLEAR_REDEMPTION_LEDGER = "@@SPARKS/CLEAR_REDEMPTION_LEDGER",

  // phase-50-w6b: the three org-wide stat cards above the pending-requests panel (phase-50-a10) -- a
  // FIFTH independent triad in this file, mirroring getRewardItems' own no-payload shape.
  GET_REDEMPTION_STATS = "@@SPARKS/GET_REDEMPTION_STATS",
  GET_REDEMPTION_STATS_SUCCESS = "@@SPARKS/GET_REDEMPTION_STATS_SUCCESS",
  GET_REDEMPTION_STATS_FAILURE = "@@SPARKS/GET_REDEMPTION_STATS_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-52-spread-your-sparks.md §4 S3: the "Spread your Sparks" section's own triad -- viewer-scoped,
  // no query params, mirroring getRewardItems'/getRedemptionStats' own no-payload shape above. A
  // SEPARATE action type from every other trio in this file (not a reuse of GET_LEADERBOARD/
  // GET_LEADERBOARD_CROWNS), same "two fetches on one screen must not cancel each other via takeLatest"
  // reasoning as getOverviewLeaderboard's own comment.
  GET_LEADERBOARD_COLLABORATORS = "@@SPARKS/GET_LEADERBOARD_COLLABORATORS",
  GET_LEADERBOARD_COLLABORATORS_SUCCESS = "@@SPARKS/GET_LEADERBOARD_COLLABORATORS_SUCCESS",
  GET_LEADERBOARD_COLLABORATORS_FAILURE = "@@SPARKS/GET_LEADERBOARD_COLLABORATORS_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-51-leaderboard-to-design.md L8: the "Your all-time" card's own rank -- viewer.rank over
  // board=received&period=All-time, a SEPARATE fetch/action type from GET_LEADERBOARD above (which
  // tracks whichever period the tab's own toggle is on). Reusing GET_LEADERBOARD's own type would let a
  // toggle click's `takeLatest` cancel this one, or vice versa, and the two must never agree by
  // accident -- this card's whole point is to stay pinned to ALL_TIME regardless of the toggle.
  GET_ALL_TIME_RANK = "@@SPARKS/GET_ALL_TIME_RANK",
  GET_ALL_TIME_RANK_SUCCESS = "@@SPARKS/GET_ALL_TIME_RANK_SUCCESS",
  GET_ALL_TIME_RANK_FAILURE = "@@SPARKS/GET_ALL_TIME_RANK_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-51-leaderboard-to-design.md L8: the same card's other two figures (best quarter, first Spark
  // received) -- `GET /recognitions/leaderboard/all-time-summary`, viewer-scoped, no query params,
  // mirroring GET_LEADERBOARD_COLLABORATORS' own no-payload shape above.
  GET_ALL_TIME_SUMMARY = "@@SPARKS/GET_ALL_TIME_SUMMARY",
  GET_ALL_TIME_SUMMARY_SUCCESS = "@@SPARKS/GET_ALL_TIME_SUMMARY_SUCCESS",
  GET_ALL_TIME_SUMMARY_FAILURE = "@@SPARKS/GET_ALL_TIME_SUMMARY_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-55-person-sparks-drawer.md §6: the "a person's Sparks" drawer's own triad -- a SEPARATE
  // action type from every other trio in this file, tagged with the subject's userId on both success
  // and failure (reducer.tsx's stale-subject guard). No CLEAR_SPARKS reset -- this is a person-KEYED
  // slot, not part of the logged-in user's own lifecycle, and gets its own CLEAR_PERSON_SPARKS below.
  GET_PERSON_SPARKS = "@@SPARKS/GET_PERSON_SPARKS",
  GET_PERSON_SPARKS_SUCCESS = "@@SPARKS/GET_PERSON_SPARKS_SUCCESS",
  GET_PERSON_SPARKS_FAILURE = "@@SPARKS/GET_PERSON_SPARKS_FAILURE",

  // 923-core-context context/engineering/spark-rewards/phase-55-person-sparks-drawer.md §6: dispatched on the drawer's unmount/close -- resets the whole
  // personSparks slot to its initial value.
  CLEAR_PERSON_SPARKS = "@@SPARKS/CLEAR_PERSON_SPARKS",
}
